import {
	createSlice,
} from '@reduxjs/toolkit';
import {
	CollectionJson,
} from '@@types/Collection';
import {
	SpecificationJson,
} from '@layouts/Pages/PageSpecifications';

export interface StoreCollectionSpecificationOffers {
	instance: CollectionJson<StoreSpecificationOffers>;
}

export interface StoreSpecificationOffers {
	offers: {
		collection: SpecificationJson[];
		count: number;
	};
	id: number;
}

// Define the initial state using that type
const initialState: StoreCollectionSpecificationOffers = {
	instance: {
		collection: [],
	},
};

export const specificationOffersSlice = createSlice({
	initialState,
	name: 'specificationOffers',
	reducers: {
		clearSpecificationOffers: (state) => {
			state.instance = initialState.instance;
		},
		setSpecificationOffers: (state, action) => {
			const findSpecification = state.instance.collection.find((specification: StoreSpecificationOffers) => specification.id && action.payload.id && specification.id === action.payload.id);

			if (findSpecification) {
				findSpecification.offers = action.payload.offers;
			} else {
				state.instance.collection = [
					...state.instance.collection,
					action.payload,
				];
			}
		},
	},
});

export const {
	setSpecificationOffers,
} = specificationOffersSlice.actions;

export const specificationOffersReducer = specificationOffersSlice.reducer;
